/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { type WithOrderItemRequestBuilder, WithOrderItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/invoices/by-order
 */
export interface ByOrderRequestBuilder extends BaseRequestBuilder<ByOrderRequestBuilder> {
    /**
     * Gets an item from the MomentumAPI.api.invoices.byOrder.item collection
     * @param orderId Unique identifier of the item
     * @returns {WithOrderItemRequestBuilder}
     */
     byOrderId(orderId: string) : WithOrderItemRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const ByOrderRequestBuilderUriTemplate = "{+baseurl}/api/invoices/by-order";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const ByOrderRequestBuilderNavigationMetadata: Record<Exclude<keyof ByOrderRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byOrderId: {
        requestsMetadata: WithOrderItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["orderId"],
    },
};
/* tslint:enable */
/* eslint-enable */
